import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
// import { header } from './utils';
import { Deployment } from '../stores/types';
import { Environment } from '../stores/types/deployment.interface';
import { header } from './http/http.service';

const DEPLOYMENT_PROXY_PATH = 'deployment';

export const deploymentApi = createApi({
  reducerPath: DEPLOYMENT_PROXY_PATH,
  baseQuery: fetchBaseQuery({
    headers: header,
    baseUrl: `/${DEPLOYMENT_PROXY_PATH}`,
  }),
  endpoints: (builder) => ({
    fetchDeployment: builder.query<Deployment, void>({
      query: () => ({
        url: `api?hostname=${window.location.hostname}`,
        method: 'GET',
      }),
    }),
    fetchEnvironment: builder.query<Environment, void>({
      query: () => ({
        url: 'environment',
        method: 'GET',
      }),
    }),
  }),
});

export const { useFetchDeploymentQuery, useFetchEnvironmentQuery } = deploymentApi;
